module.exports = __webpack_public_path__ + "static/media/1600x900-white-solid-color-background.7406d141.jpg";